import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

const data = [
    {route: 'applicant', value: 'item1', text: 'مدیریت متقاضیان', icon: 'fa-solid fa-address-book' },
    {route: 'driver', value: 'item2', text: 'مدیریت رانندگان', icon: 'fa-solid fa-truck' },
    {route: 'request', value: 'item3', text: 'مدیریت درخواست ها', icon: 'fa-envelope' },
    {route: 'report', value: 'item4', text: 'گزارش گیری', icon: 'fa-book' },
    {route: 'users', value: 'item5', text: 'مدیریت کاربران', icon: 'fa-users' },
]

const RightMenu = () => {
    const [hideMenu, setHideMenu] = useState(false)
    const [selectedItem, setSelectedItem] = useState('item1')
    const navigate = useNavigate();
    const handleShowAndHide = () => {
        setHideMenu(!hideMenu)
    }

    useEffect(() => {
        function handleResize(){
            if(window.innerWidth < 992){
                setHideMenu(true)
            }
            else {
                setHideMenu(false)
            }
        }
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const handleClick = (e, item) => {
        setSelectedItem(item)
        if(window.innerWidth < 992){
            setHideMenu(true)
        }
    }

    return(
        <div className={`${hideMenu ? 'w-[20%] sm:w-[15%] md:w-[8%] lg:w-[4%]' : 'w-[40%] sm:w-[35%] md:w-[30%] lg:w-[20%] xl:w-[15%]'} flex-col
         items-center gap-3 pt-5 shadow-xl box-border [clip-path:inset(0 0 0 -30px)] transition-all duration-500`}
        >
            <div><i className="fa fa-bars text-2xl text-gray-500 hover:cursor-pointer hover:text-green-500" onClick={handleShowAndHide}></i></div>
            <div className='block w-full flex flex-col gap-3 mt-5'>
                {data.map((item, index) => {
                      if (item.value === 'item5' && localStorage.getItem('userName') !== 'ادمین') {
                        return null;
                    }
                    return(
                        <div key={index} className={`w-full flex flex-col flex-col-reverse gap-1 md:flex-row rounded-md ${hideMenu ? 'justify-center' : 'justify-between'} items-center px-4 text-gray-700 hover:cursor-pointer hover:text-green-500
                             ${selectedItem === item.value ? 'bg-transparent text-green-500' : ''} py-1 md:py-3`}
                             onClick={(e) => {navigate(item.route);handleClick(e, item.value)}}>
                            <div className={`text-[10px] md:text-xs font-bold overflow-hidden whitespace-nowrap text-center grow ${hideMenu ? 'hidden' : 'block'}`}>{item.text}</div>
                            <i className={`fa text-sm md:text-md text-left transition-all duration-300 ${item.icon}`}></i>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default RightMenu